import { useContext } from 'react';
import { GlobalStateContext } from './GlobalStateProvider';

export const useGlobal = () => {
  const { state, dispatch } = useContext(GlobalStateContext);

  const globalState = state;
  const globalDispatch = dispatch;

  dispatch.updatePayConfig = payConfig => {
    dispatch({ key: 'payConfig', value: payConfig });
  };

  dispatch.loadingTrue = loading => {
    dispatch({ key: 'loading', value: true });
  };

  dispatch.loadingFalse = loading => {
    dispatch({ key: 'loading', value: false });
  };

  return {
    globalState,
    globalDispatch,
  };
};
